module.exports = __webpack_public_path__ + "static/media/41-4.245a0973.mp3";